const saeolSelectOptions = [
  {value: '00', label: '00 (정상)'},
  {value: '01', label: '01 (회전)'},
  {value: '02', label: '02 (교체)'},
  {value: '03', label: '03 (인정)'},
  {value: '04', label: '04 (부동)'},
  {value: '05', label: '05 (누수)'},
  {value: '06', label: '06 (중지)'},
  {value: '07', label: '07 (미검침)'},
  {value: '08', label: '08 (자가검침)'},
  {value: '09', label: '09 (공업용수)'},
]

const wimsSelectOptions = [
  {value: '1', label: '1 (정상)'},
  {value: '2', label: '2 (인정)'},
  {value: '3', label: '3 (고장)'},
  {value: '4', label: '4 (교체)'},
  {value: '5', label: '5 (회전)'},
  {value: '6', label: '6 (폐전)'},
  {value: '7', label: '7 (휴전)'},
  {value: '0', label: '0 (미검침)'},
]

const crebizSelectOptions = [
  {value: '001', label: '001 (정상)'},
  {value: '002', label: '002 (개조)'},
  {value: '003', label: '003 (고장)'},
  {value: '004', label: '004 (동파)'},
  {value: '005', label: '005 (노후)'},
  {value: '006', label: '006 (파손)'},
  {value: '007', label: '007 (망실)'},
  {value: '008', label: '008 (검증)'},
]

const bluewaterSelectOptions = [
  {value: '정상', label: '정상'},
  {value: '점검필요', label: '점검필요'},
]

const bluewaterSelectOptionsYeongwol = [
  {value: '00', label: '00 (정상)'},
  {value: '01', label: '01 (부동)'},
  {value: '02', label: '02 (인정)'},
  {value: '03', label: '03 (정산)'},
  {value: '04', label: '04 (교체)'},
  {value: '05', label: '05 (회전)'},
  {value: '06', label: '06 (미검)'},
  {value: '07', label: '07 (휴전)'},
  {value: '09', label: '09 (기능시험)'},
  {value: '10', label: '10 (기타)'},
  {value: '11', label: '11 (신규)'},
  {value: '12', label: '12 (물흘림 감면)'},
  {value: '31', label: '31 (주천 인정조정)'},
  {value: '98', label: '98 (이사정산-연체)'},
  {value: '99', label: '99 (이사정산)'},
]

export const ProgramsSelectOptions = (programName: any, officeCode: any) => {
  switch (programName) {
    case 'WIMS':
      return wimsSelectOptions
    case 'SAEOL':
    case 'SAEOL1':
      return saeolSelectOptions
    case 'BLUEWATER':
      switch (officeCode) {
        case 'D101':
          return bluewaterSelectOptionsYeongwol
      }
      return bluewaterSelectOptions
    case 'CREBIZ':
      return crebizSelectOptions
    default:
      return []
  }
}
